import { INITIAL_CAUSALITY_DETAIL } from '../../../../../routes/paths';
import { Table } from '../../../../components/general/table';
import { useInitialCausalityList } from './hook';
import { InitialCausalityListProps } from './props';

export const InitialCausalityList = ({
    filters,
}: InitialCausalityListProps) => {
    const { columns, rows, loading, page, pageSize, paginator, total } =
        useInitialCausalityList(filters);

    return (
        <Table
            columns={columns}
            rows={rows}
            rowCount={total}
            loading={loading}
            paginationModel={{
                page,
                pageSize,
            }}
            onPaginationModelChange={paginator}
            pageSizeOptions={[2, 10, 20, 50]}
            disableRowSelectionOnClick
            onRowClick={(item) =>
                window.open(
                    `${INITIAL_CAUSALITY_DETAIL}/${item.row.id}`,
                    '_blank'
                )
            }
        />
    );
};
